// Path: assets/ps-hydrator.js
//
// Minimal hydrator for Hybrid Dynamic PDP.
//
// Responsibilities:
// - Read Edge payload via PS.ssr().
// - Seed ps_cc cookie with make/color/code/hex.
// - Initialize PS.PDP (year gate, clearcoat multi-add) on PDPs.
// - MakeColor handshake: if PS_SSR.products[] exists, render 4 canonical PDP links
//   into a known container without extra API calls.
//
// Removed:
// - Client API fetching, URL parsing, ps:color:* events, text replacement, image swaps.

(function(window, document){
  'use strict';

  var PS = window.PS || (window.PS = {});

  // ---------------- helpers ----------------
  function onReady(cb){
    if (!cb) return;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cb);
    else cb();
  }

  function norm(v){ return (v == null ? '' : String(v)); }
  function lower(v){ return norm(v).toLowerCase(); }

  function parseColorContextFromUrl(url){
    var str = norm(url);
    var a = null;
    var path = '';
    var match = null;
    if (!str) return null;
    try {
      a = document.createElement('a');
      a.href = str;
      path = norm(a.pathname);
    } catch (_e) {
      path = str;
    }
    match = path.match(/^\/colors\/([^\/?#]+)\/([^\/?#]+)/i);
    if (!match) return null;
    return {
      make_slug: lower(match[1]),
      color_slug: lower(match[2])
    };
  }

  function readLastColorContext(){
    var raw = '';
    var parsed = null;
    try {
      raw = window.sessionStorage ? window.sessionStorage.getItem('ps_last_color_context') : '';
    } catch (_e) {
      raw = '';
    }
    if (!raw) return null;
    try {
      parsed = JSON.parse(raw);
    } catch (_e2) {
      parsed = null;
    }
    if (!parsed || !parsed.make_slug || !parsed.color_slug) return null;
    return {
      make_slug: lower(parsed.make_slug),
      color_slug: lower(parsed.color_slug)
    };
  }

  function writeLastColorContext(context){
    var payload = null;
    if (!context || !context.make_slug || !context.color_slug) return;
    payload = {
      make_slug: lower(context.make_slug),
      color_slug: lower(context.color_slug)
    };
    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem('ps_last_color_context', JSON.stringify(payload));
      }
    } catch (_e) {}
  }

  function readLastVehicleContext(){
    var raw = '';
    var parsed = null;
    try {
      raw = window.sessionStorage ? window.sessionStorage.getItem('ps_last_vehicle_context') : '';
    } catch (_e) {
      raw = '';
    }
    if (!raw) return null;
    try {
      parsed = JSON.parse(raw);
    } catch (_e2) {
      parsed = null;
    }
    if (!parsed || !parsed.make_slug || !parsed.color_slug) return null;
    return {
      make_slug: lower(parsed.make_slug),
      color_slug: lower(parsed.color_slug),
      year: norm(parsed.year),
      model: norm(parsed.model),
      factory_code: norm(parsed.factory_code),
      ps_from_search: parsed.ps_from_search === true || norm(parsed.ps_from_search) === 'true'
    };
  }

  function writeLastVehicleContext(context, fields){
    var payload = null;
    var data = fields || {};
    if (!context || !context.make_slug || !context.color_slug) return;
    payload = {
      make_slug: lower(context.make_slug),
      color_slug: lower(context.color_slug),
      year: norm(data.year),
      model: norm(data.model),
      factory_code: norm(data.factory_code),
      ps_from_search: data.ps_from_search === true || norm(data.ps_from_search) === 'true'
    };
    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem('ps_last_vehicle_context', JSON.stringify(payload));
      }
    } catch (_e) {}
  }

  function readPendingVehicleColorContext(context){
    var raw = '';
    var parsed = null;
    var age = 0;
    if (!context || !context.make_slug || !context.color_slug) return null;
    try {
      raw = window.sessionStorage ? window.sessionStorage.getItem('ps_pending_vehicle_color_context') : '';
    } catch (_e) {
      raw = '';
    }
    if (!raw) return null;
    try {
      parsed = JSON.parse(raw);
    } catch (_e2) {
      parsed = null;
    }
    if (!parsed) return null;
    age = Date.now() - Number(parsed.ts || 0);
    if (!parsed.ts || age > (10 * 60 * 1000) || age < -(60 * 1000)) {
      try { if (window.sessionStorage) window.sessionStorage.removeItem('ps_pending_vehicle_color_context'); } catch (_e3) {}
      return null;
    }
    if (lower(parsed.make_slug) !== lower(context.make_slug) || lower(parsed.color_slug) !== lower(context.color_slug)) {
      clearPendingVehicleColorContext();
      return null;
    }
    if (!norm(parsed.year)) return null;
    return {
      make_slug: lower(parsed.make_slug),
      color_slug: lower(parsed.color_slug),
      year: norm(parsed.year),
      model: norm(parsed.model),
      factory_code: ''
    };
  }

  function clearPendingVehicleColorContext(){
    try {
      if (window.sessionStorage) window.sessionStorage.removeItem('ps_pending_vehicle_color_context');
    } catch (_e) {}
  }

  function resolvePreviousColorContext(){
    return readLastColorContext() || parseColorContextFromUrl(document.referrer || '');
  }

  function isColorContextChanged(prev, current){
    if (!prev || !current) return false;
    if (!prev.make_slug || !prev.color_slug || !current.make_slug || !current.color_slug) return false;
    return prev.make_slug !== current.make_slug || prev.color_slug !== current.color_slug;
  }

  function hasTrustedVehicleScope(data){
    return !!(data && (data.vehicle_scope === true || norm(data.vehicle_scope) === 'true'));
  }

  function seedCookieFromSSR(ssr){
    if (!ssr || !PS.cc || !PS.cc.write) return;
    var targetMakeSlug = norm(ssr.make_slug).toLowerCase();
    var targetColorSlug = norm(ssr.color_slug).toLowerCase();
    var matchingBeforeNormalize = (PS.cc.readForColor && PS.cc.readForColor(targetMakeSlug, targetColorSlug)) || null;
    try {
      if (typeof PS.cc.normalizeColorContext === 'function') PS.cc.normalizeColorContext();
    } catch (_e) {}
    var w = {
      make:       norm(ssr.make),
      color:      norm(ssr.color),
      code:       norm(ssr.code),
      hex:        norm(ssr.hex).replace('#',''),
      make_slug:  targetMakeSlug,
      color_slug: targetColorSlug
    };
    var currentContext = {
      make_slug: w.make_slug,
      color_slug: w.color_slug
    };
    var existing = matchingBeforeNormalize || (PS.cc.readForColor && PS.cc.readForColor(w.make_slug, w.color_slug)) || (PS.cc.read && PS.cc.read()) || {};
    var existingMakeSlug = norm(existing.make_slug).toLowerCase();
    var existingColorSlug = norm(existing.color_slug).toLowerCase();
    var previousContext = resolvePreviousColorContext();
    var storedVehicleContext = readLastVehicleContext();
    var pendingVehicleContext = readPendingVehicleColorContext(currentContext);
    var colorContextChanged = isColorContextChanged(previousContext, currentContext);
    var trustedExistingVehicleContext = false;
    var trustedStoredVehicleContext = false;
    var trustedPendingVehicleContext = false;
    var freshVehicleSearchTransition = false;
    var colorProductRoute = isColorProductRoute();
    var sameStoredVehicleContext = !!(
      storedVehicleContext &&
      storedVehicleContext.make_slug === currentContext.make_slug &&
      storedVehicleContext.color_slug === currentContext.color_slug
    );
    var sameColorContext = !!(
      w.make_slug &&
      w.color_slug &&
      existingMakeSlug === w.make_slug &&
      existingColorSlug === w.color_slug
    );
    var sameMakeVehicleOnlyContext = !!(
      w.make_slug &&
      existingMakeSlug === w.make_slug &&
      !existingColorSlug &&
      norm(existing.year) &&
      norm(existing.model)
    );
    freshVehicleSearchTransition = !!(
      pendingVehicleContext ||
      (colorContextChanged && (existing.ps_from_search === true || norm(existing.ps_from_search) === 'true')) ||
      (sameStoredVehicleContext && storedVehicleContext.ps_from_search === true)
    );
    trustedPendingVehicleContext = !!(pendingVehicleContext && pendingVehicleContext.year);
    trustedExistingVehicleContext = hasTrustedVehicleScope(existing) && !!norm(existing.year) && (!colorContextChanged || freshVehicleSearchTransition);
    trustedStoredVehicleContext = sameStoredVehicleContext && !!norm(storedVehicleContext.year) && !colorContextChanged;
    // Preserve year/model only when the matching cookie came from an explicit
    // vehicle color selection or PDP vehicle prompt.
    if (((sameColorContext || sameMakeVehicleOnlyContext) && trustedExistingVehicleContext) || trustedStoredVehicleContext || trustedPendingVehicleContext) {
      if (trustedPendingVehicleContext) w.year = String(pendingVehicleContext.year);
      else if (trustedExistingVehicleContext && existing && existing.year) w.year = String(existing.year);
      else if (sameStoredVehicleContext && storedVehicleContext.year) w.year = String(storedVehicleContext.year);
      if (trustedPendingVehicleContext && pendingVehicleContext.model) w.model = String(pendingVehicleContext.model);
      else if (trustedExistingVehicleContext && existing && existing.model) w.model = String(existing.model);
      else if (sameStoredVehicleContext && storedVehicleContext.model) w.model = String(storedVehicleContext.model);
      if (sameColorContext && trustedExistingVehicleContext && !freshVehicleSearchTransition && existing && existing.factory_code) w.factory_code = String(existing.factory_code);
      else if (sameColorContext && sameStoredVehicleContext && !freshVehicleSearchTransition && storedVehicleContext.factory_code) w.factory_code = String(storedVehicleContext.factory_code);
      else w.factory_code = '';
      w.vehicle_scope = true;
    } else {
      w.year = '';
      w.model = '';
      w.factory_code = '';
      w.vehicle_scope = false;
    }
    // The PDP consumes this marker only after the required fresh factory-code
    // step succeeds. Keeping it here also blocks exact-color cart reuse.
    w.ps_from_search = !!freshVehicleSearchTransition;
    PS.cc.write(w);
    // Keep the exact-target vehicle-search handoff through the Color Hub so
    // featured-card cart forms cannot consume it before the selected PDP. The
    // PDP consumes it after writing fresh year/model with a blank factory code.
    if (trustedPendingVehicleContext && colorProductRoute) clearPendingVehicleColorContext();
    writeLastColorContext(currentContext);
    writeLastVehicleContext(currentContext, w);
  }

  function isPdp(){
    return !!document.querySelector('form[action^="/cart"] [type="submit"], form[action*="/cart/add"] [type="submit"]');
  }

  function isColorProductRoute(){
    var path = norm(window.location && window.location.pathname).toLowerCase();
    return /^\/colors\/[^\/?#]+\/[^\/?#]+\/(?:pen|bottle|spray|pro|kit-pen|kit-bottle|kit-spray)\/?$/.test(path);
  }

function bootstrap(){
    var ssr = (PS.ssr && PS.ssr()) || null;
    // Nothing to do if invalid; Worker handles 404s.
    if (!ssr || !ssr.valid) return;

    // Persist browse tuple in cookie for continuity
    seedCookieFromSSR(ssr);

    // Initialize PDP controller (year gate, clearcoat)
    if (isPdp() && PS.PDP && typeof PS.PDP.init === 'function'){
      PS.PDP.init();
    }
  }

  onReady(bootstrap);

})(window, document);
